bam-social-share {
  button.bam-social-share-trigger {
    border-radius: 0 0 4px 4px !important;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: -2px;
      width: 8px;
      height: 8px;
      background-color: white;
    }

    &:before {
      left: -10px;
      background-image: radial-gradient(ellipse at left bottom, #000d6e 70%, #ffffff 30%, #ffffff 100%);
    }

    &:after {
      right: -10px;
      background-image: radial-gradient(ellipse at right bottom, #000d6e 70%, #ffffff 30%, #ffffff 100%);
    }
  }

  dialog {
    width: 640px;
    background: white;
    border-radius: var(--bal-radius-large);
    border: none;
    margin-top: 48px;
    padding: 0;

    &::backdrop {
      background-color: #000739;
      opacity: 0.6;
    }

    & .dialog-content {
      padding: 16px;
    }

    color: var(--bal-color-primary) !important;
    
    & ul li:first-child {
      bal-button[color='success'] {
        pointer-events: none;
      }
    }
  }
}
